function globalErrors(out, errors) {
    //prise en compte des erreurs globals
    if (errors.length > 0) {
        const msg = errors.map(e => e.defaultMessage);
        if (msg?.length) {
            out.subtext = [...msg];
        }
    }
}

/**
 * Création d'une méthode snackbar permettant d'afficher un message. L'idée est d'avoir un message simple affiché quelque soit la route
 * @param {*} options
 * @returns
 */
export default function makeVuexSnackbar(options = {}) {
    const { method = "snackbar" } = options;
    return {
        methods: {
            [method]({ text, subtext, color, timeout = 5000 }, exception) {
                const out = { text, subtext, color, timeout };
                if (exception) {
                    const status = exception.response?.status || 200;
                    const errors = exception.response?.data?.globalErrors || [];
                    out.color = "error";
                    if ([413].includes(status)) {
                        out.subtext = "Tailles des annexes trop élevée."
                    } else if ([400, 412].includes(status)) {
                        globalErrors(out, errors);
                    } else if ("Network Error" === exception.message) {
                        out.subtext = "Erreur de communication."
                    } else {
                        out.subtext = exception.message;
                    }
                }
                this.$store.commit("snackbar/display", out);
            },
        },
    };
}

export const VuexSnackbar = makeVuexSnackbar();
